<template>
  <div class="search-container">
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.workOrderId"
        size="large"
        placeholder="请输入工单ID"
        allowClear
        @input="inputR($event, 'workOrderId', 3)"
      />
    </div>
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.erpSn"
        size="large"
        placeholder="请输入Erp编号"
        allowClear
      />
    </div>
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.ucBdName"
        size="large"
        placeholder="请输入姓名"
        allowClear
      />
    </div>
    <div class="search-item">
      <a-input
        class="search-input"
        v-model:value="formState.parentId"
        size="large"
        placeholder="请输入关联健管工单ID"
        allowClear
        @input="inputR($event, 'parentId', 3)"
      />
    </div>
    <div class="search-item">
      <a-select
        v-model:value="formState.businessType"
        placeholder="请选择工单类型"
        style="width: 224px"
        size="large"
      >
        <a-select-option
          v-for="option in workOrderTypeMap"
          :value="option.eventType"
          :key="option.eventType"
        >
          {{ option.eventTypeContent }}
        </a-select-option>
      </a-select>
    </div>
    <div class="search-item">
      <a-range-picker
        size="large"
        v-model:value="formState.orderCycle"
        :placeholder="['工单开始时间', '工单结束时间']"
        allowClear
        :showTime="showTimeObj"
        format="YYYY-MM-DD"
        class="search-picker"
        valueFormat="YYYY-MM-DD HH:mm:ss"
        :disabledDate="disabledDate"
      />
    </div>
    <div class="search-item">
      <a-button
        class="search-button"
        size="large"
        type="primary"
        @click="searchList"
        :loading="loading"
      >
        搜索
      </a-button>
    </div>
  </div>
</template>
<script setup>
import { defaultQuery, workOrderTypeMap } from './options'
import { inputRule } from '@/utils/validate'
import { reactive, defineEmits, defineProps, watch } from 'vue'
import moment from 'moment'
import { cloneDeep } from 'lodash-es'

const props = defineProps({
  queryParams: {
    type: Object,
    default: () => ({})
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const formState = reactive({ ...defaultQuery })

const emits = defineEmits(['searchList'])
const showTimeObj = reactive({
  format: 'HH:mm:ss',
  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
})

//控制输入规则
function inputR(e, key, type) {
  formState[key] = inputRule(e.target.value, type)
}

function searchList() {
  emits('searchList', {
    ...cloneDeep(formState),
    curPage: 1,
    pageSize: 10
  })
}

const disabledDate = current => {
  return current && current < moment('2024-1-1 00:00:00')
}

watch(
  () => props.queryParams,
  value => {
    Object.assign(formState, {
      ...defaultQuery,
      ...cloneDeep(value || {}),
      orderCycle: Array.isArray(value?.orderCycle) ? value.orderCycle : []
    })
  },
  {
    immediate: true,
    deep: true
  }
)
</script>
<style lang="scss">
.creatTime .ant-calendar-footer-btn .ant-tag {
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.search-container {
  padding: 10px 20px 0;
  background-color: #ffffff;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search-input {
      width: 224px;
    }
  }
}
</style>
